import { render, staticRenderFns } from "./BatchMatchTransaction.vue?vue&type=template&id=7dd1f74c&"
import script from "./BatchMatchTransaction.vue?vue&type=script&lang=js&"
export * from "./BatchMatchTransaction.vue?vue&type=script&lang=js&"
import style0 from "./BatchMatchTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports